/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
/**
 *  Valid string resource types.
 */
enum RESOURCE {
    // Webtop Resources
    APP_TUNNEL = 'app_tunnel',
    NETWORK_ACCESS = 'network_access',
    REMOTE_DESKTOP = 'remote_desktop',
    PORTAL_ACCESS = 'portal_access', // FAO 'web_app' is returned in resourceInfo
    SAML = 'saml',
    WEBTOP_LINK = 'webtop_link',
    // Webtop Components
    WEBTOP_FOLDER = 'webtop_folder',
    WEBTOP_SECTION = 'webtop_section',
    WEBTOP = 'webtop',
    // OAuth Resources
    OAUTH_CLIENT_APP = 'client_app',
    OAUTH_SCOPE = 'scope',
}

const RESOURCE_TO_SECTION = [
    /* 0 */ RESOURCE.PORTAL_ACCESS,
    /* 1 */ RESOURCE.WEBTOP_LINK,
    /* 2 */ RESOURCE.APP_TUNNEL,
    /* 3 */ RESOURCE.REMOTE_DESKTOP,
    /* 4 */ RESOURCE.NETWORK_ACCESS,
    /* 5 */ RESOURCE.SAML,
];

const RESOURCE_WEBTOP = [...RESOURCE_TO_SECTION, RESOURCE.WEBTOP_SECTION, RESOURCE.WEBTOP];

const RESOURCE_OAUTH = [RESOURCE.OAUTH_CLIENT_APP, RESOURCE.OAUTH_SCOPE];

const RESOURCE_VALUES = [...RESOURCE_WEBTOP, ...RESOURCE_OAUTH];

export { RESOURCE, RESOURCE as default, RESOURCE_TO_SECTION, RESOURCE_OAUTH, RESOURCE_VALUES };
